import {api} from '../../contexts/AuthContext';
import {InsightsData} from '../../types';

// Insights API
export const insightsApi = {
    get: async (analysisType?: 'all' | 'brand-safety' | 'audience-targeting', companyId?: string): Promise<InsightsData> => {
        const params = new URLSearchParams();
        if (analysisType && analysisType !== 'all') {
            params.append('type', analysisType);
        }
        if (companyId) {
            params.append('companyId', companyId);
        }
        const queryString = params.toString();
        const response = await api.get(`/api/insights${queryString ? `?${queryString}` : ''}`);
        return response.data;
    },

    getForPrompt: async (promptId: string, companyId?: string, days?: number): Promise<InsightsData> => {
        const params = new URLSearchParams({promptId});
        if (companyId) {
            params.append('companyId', companyId);
        }
        if (days) {
            params.append('days', String(days));
        }
        const response = await api.get(`/api/insights?${params.toString()}`);
        return response.data;
    },
};
